import { render } from "./QuranVerses.vue?vue&type=template&id=d6619a82&ts=true"
import script from "./QuranVerses.vue?vue&type=script&lang=ts"
export * from "./QuranVerses.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__